module.exports = __webpack_public_path__ + "img/nhif-guide.b2e3ad5d.jpg";